<app-examiner-form
  [examReportId]="examReportId"
  [navigateBackUrl]="navigateBackData"
  [navigateToUrl]="navigateToData"
></app-examiner-form>
